import { Modal } from 'telia-front-react';
import { inject } from 'mobx-react';
import * as React from 'react';

import { IModalStore } from '../../../stores/ModalStore';
import { registerError } from '../../../util/ErrorUtil';
import WarningNotice from '../notices/WarningNotice';

interface IClosableModalProps {
  children: React.ReactChild | React.ReactChild[];
  modalStore?: IModalStore;
  onClose?: () => void;
  className?: string;
  size?: '10-col' | '8-col' | '6-col';
  errorNoticeTranslationKey?: string;
}

interface IClosableModalState {
  hasError: boolean;
}

@inject('modalStore')
export default class ClosableModal extends React.Component<IClosableModalProps, IClosableModalState> {
  constructor(props: IClosableModalProps) {
    super(props);
    this.state = { hasError: false };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({ hasError: true });
    console.error(error, errorInfo);
    registerError(error);
  }

  public render(): JSX.Element {
    return (
      <Modal
        isOpen={true}
        onClose={() => (this.props.onClose ? this.props.onClose() : this.props.modalStore.closeModal())}
        className={this.props.className}
        size={this.props.size}
      >
        {this.renderModalChildren()}
      </Modal>
    );
  }

  private renderModalChildren() {
    if (this.state.hasError) {
      const translationKey = this.props.errorNoticeTranslationKey || 'shared.errors.technical';
      return <WarningNotice translationKey={translationKey} />;
    }
    return this.props.children;
  }
}
